import { ResponseBase } from '@/services/types'
import { shopCLient } from '../../axiosConfig'
import { Subcategory } from './subcategories'

export interface GetCategoriesRes {
  productCategoryPopulateDtos: Category[]
}
export interface Category {
  id: number
  nameMn: string
  nameEn: string
  link?: string
  productSubCategoryDto?: Subcategory[]
}

export type GetCategories = () => Promise<ResponseBase<GetCategoriesRes>>

export const getCategories: GetCategories = async () => {
  try {
    const response = await shopCLient.get('/product/category-populate')
    return response.data
  } catch (e) {
    console.error('categories fetch failed e')
  }
}
